DigiTickets.MembershipRefundType = Object.freeze({
    NONE: 'none',
    UNUSED: 'unused', // AKA 'outstanding'
    ALL: 'all'
});
